import axios from "../utils/request";
// 会员列表  ok
export const getUserListApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/users',
		params
	})
}
// 会员详情  ok
export const userDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/users/${params.userId}`,
		params
	})
}
// 操作日志 ok
export const operationLogApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/operation/log',
		params
	})
}

// 加入黑名单-解除黑名单 OK
export const userBlackApi = function(data) {
	return axios({
		method: "PUT",
		url: `/pet/manager/user/black/${data.userId}`,
		data
	});
};

// 修改账户状态 接口开发中
export const userStatusApi = function(data) {
	return axios({
		method: "PUT",
		url: `/pet/manager/user/status/${data.userId}`,
		data
	});
};

// 会员导出 接口开发中
export const usersExportApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/users/export',
		params,
		responseType: 'blob'
	})
}

// 工厂/品牌列表
export const managerFactoryApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/factories',
		params
	})
}
// 工厂/品牌详情 -基础信息/经营信息/品控溯源/工商信息
export const managerFactoryDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/factories/${params.businessLangId}`,
		params
	})
}
// 工厂/品牌列表 导出 todo
export const factoriesExportApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/factories/export',
		params,
		responseType: 'blob'
	})
}
// 工厂/品牌列表 导入 todo
export const factoriesImportApi = (formData,businessType) => {
	return axios({
		method: 'post',
		url: '/pet/manager/factories/import',
		data: formData,
		params: { businessType: businessType },
		headers: { 'Content-Type': 'multipart/form-data' }
	})
}

export const factoriesImportTemplateApi = () => {
	return axios({
		method: 'get',
		url: '/pet/manager/factories/import/template',
		responseType: 'blob'
	})
}

// 工厂/品牌详情 -基础信息新增/编辑 POST
// {{url1}}/pet/manager/factories/base/info/{businessLangId}
export const factoryBaseInfoApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/factories/base/info/${data.businessLangId}`,
		data
	})
}

// 工厂/品牌详情 -经营信息编辑 post
// {{url1}}/pet/manager/factories/business/scale/{businessLangId}
export const factoryBusinessApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/factories/business/scale/${data.businessLangId}`,
		data
	})
}
// {{url1}}/pet/manager/factories/quality/traceability/{businessLangId}
// 工厂/品牌详情 -品控溯源编辑
export const factoryQualityApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/factories/quality/traceability/${data.businessLangId}`,
		data
	})
}

// 工厂/品牌详情 -工商信息编辑
// {{url1}}/pet/manager/factories/business/license/info/{businessLangId}
export const factoryLicenseInfoApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/factories/business/license/info/${data.businessLangId}`,
		data
	})
}
// 工厂/品牌-删除
export const deleteFactoryApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/factories/${data.businessLangId}`,
	})
}

// 工厂/品牌列表 发布状态修改
export const updateFactoryStatusApi = (data) => {
	return axios({
		method: 'PUT',
		url: `/pet/manager/factories/status/${data.businessLangId}`,
		data
	})
}

// 工厂/品牌列表 正经工厂状态
export const updateFactoryIndexStatusApi = (data) => {
	return axios({
		method: 'PUT',
		url: `/pet/manager/factories/index/status/${data.businessLangId}`,
		data
	})
}

// 工厂/品牌列表 排序
export const updateFactorySortApi = (data) => {
	return axios({
		method: 'PUT',
		url: `/pet/manager/factories/${data.businessLangId}/sort/${data.sort}`,
		data
	})
}

// 工厂/品牌列表 正经工厂排序
export const updateFactoryIndexSortApi = (data) => {
	return axios({
		method: 'PUT',
		url: `/pet/manager/factories/${data.businessLangId}/index/sort/${data.sort}`,
		data
	})
}

// 工厂/品牌列表 编辑评分
export const updateFactoryRatingApi = (data) => {
	return axios({
		method: 'PUT',
		url: `/pet/manager/factories/${data.businessLangId}/avg/rating`,
		data
	})
}

// 工厂/品牌 主营产品
export const getFactoryProductsApi = (params) => {
	return axios({
		method: 'get',
		url: "/pet/manager/factory/products",
		params
	})
}

// 工厂/品牌 主营产品详情
export const getFactoryProductDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/factory/products/${params.factoryProductId}`,
		params
	})
}

// 工厂/品牌 主营产品 新增/编辑
export const saveFactoryProductApi = (data) => {
	return axios({
		method: 'POST',
		url: `pet/manager/factory/products/${data.factoryProductId}`,
		data
	})
}

// 工厂/品牌 主营产品 删除
export const deleteFactoryProductApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/factory/products/${data.factoryProductId}`,
	})
}

// 工厂/品牌 主营产品 导出
export const exportFactoryProductsApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/factory/products/export`,
		params,
		responseType: 'blob'
	})
}


// 工厂/品牌 主营产品 修改状态
export const updateFactoryProductStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/factory/products/${data.factoryProductId}`,
		data
	})
}

// 工厂/品牌 主营产品 修改序号
export const updateFactoryProductSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/factory/products/${data.factoryProductId}/sort/${data.sort}`,
		data
	})
}

// 工厂/品牌 口碑评价
export const getFactoryCommentsApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/factory/comments`,
		params
	})
}

// 工厂/品牌 口碑评价详情
export const getFactoryCommentDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/factory/comments/${params.commentId}`,
		params
	})
}

// 工厂/品牌 口碑评价 新增/编辑
export const saveFactoryCommentApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/factory/comments/${data.commentId}`,
		data
	})
}

// 工厂/品牌 口碑评价 删除
export const deleteFactoryCommentApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/factory/comments/${data.commentId}`
	})
}

// 工厂/品牌 口碑评价 状态
export const updateFactoryCommentStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/factory/comments/${data.commentId}`,
		data
	})
}

// 工厂/品牌 口碑评价 排序
export const updateFactoryCommentSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/factory/comments/${data.commentId}/sort/${data.sort}`,
		data
	})
}
// 工厂品牌end
// 标签管理 start
// 标签设置列表
export const getTagCategoriesApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/tag/cateogres`,
		params
	})
}

// 标签设置详情
export const getTagCategoryDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/tag/cateogres/${params.tagCategoryId}`,
		params
	})
}

// 标签设置编辑
export const updateTagCategoryApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/tag/cateogres/${data.tagCategoryId}`,
		data
	})
}

// 工厂/品牌/供应商列表
export const getBusinessEntitiesApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/business/entites`,
		params
	})
}

// 工厂/品牌/供应商详情
export const getBusinessEntityDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/business/entites/${params.businessId}`,
		params
	})
}

// 工厂/品牌/供应商新增/编辑
export const saveBusinessEntityApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/business/entites/${data.businessId}`,
		data
	})
}
// 工厂/品牌/供应商 状态
// {{url1}}/pet/manager/business/entites/{businessId}/status
export const updateBusinessEntityStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/business/entites/${data.businessId}/status`,
		data
	})
}

// 工厂/品牌/供应商删除
export const deleteBusinessEntityApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/business/entites/${data.businessId}`
	})
}

// 工厂/品牌/供应商 排序
export const updateBusinessEntitySortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/business/entites/${data.businessId}/sort/${data.sort}`,
		data
	})
}

// 首页筛选
export const getIndexSearchApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/index/search`,
		params
	})
}

// 首页筛选 编辑
export const updateIndexSearchApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/index/search`,
		data
	})
}
// 标签管理 end

// 法规管理 start
// 执行标准 导入
export const importExecutionStandardApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/execution/standards/import`,
		data
	})
}

// 执行标准列表
export const getExecutionStandardListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/execution/standards`,
		params
	})
}
// 执行标准详情
export const getExecutionStandardDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/execution/standards/${params.executionStandardId}`,
		params
	})
}

// 执行标准新增/编辑
export const saveExecutionStandardApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/execution/standards/${data.executionStandardId}`,
		data
	})
}


// 执行标准删除
export const deleteExecutionStandardApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/execution/standards/${data.executionStandardId}`
	})
}

// 执行标准 修改状态
export const updateExecutionStandardStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/execution/standards/${data.executionStandardId}/status`,
		data
	})
}

// 执行标准 修改排序
export const updateExecutionStandardSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/execution/standards/${data.executionStandardId}/sort/${data.sort}`,
		data
	})
}

// 法律法规列表
export const getRegulationsListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/regulations`,
		params
	})
}

// 法律法规详情
export const getRegulationDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/regulations/${params.regulationId}`,
		params
	})
}

// 法律法规新增/编辑
export const saveRegulationApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/regulations/${data.regulationId}`,
		data
	})
}

// 法律法规删除
export const deleteRegulationApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/regulations/${data.regulationId}`
	})
}

// 法律法规 修改状态
export const updateRegulationStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/regulations/${data.regulationId}/status`,
		data
	})
}

// 法律法规 修改排序
export const updateRegulationSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/regulations/${data.regulationId}/sort/${data.sort}`,
		data
	})
}

// 处罚案例 导入
export const importPenaltyCaseApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/penalty/cases/import`,
		data
	})
}

// 处罚案例列表
export const getPenaltyCaseListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/penalty/cases`,
		params
	})
}

// 处罚案例详情
export const getPenaltyCaseDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/penalty/cases/${params.caseId}`,
		params
	})
}

// 处罚案例新增/编辑
export const savePenaltyCaseApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/penalty/cases/${data.caseId}`,
		data
	})
}

// 处罚案例删除
export const deletePenaltyCaseApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/penalty/cases/${data.caseId}`
	})
}

// 处罚案例 修改状态
export const updatePenaltyCaseStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/penalty/cases/${data.caseId}/status`,
		data
	})
}

// 处罚案例 修改排序
export const updatePenaltyCaseSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/penalty/cases/${data.caseId}/sort/${data.sort}`,
		data
	})
}

// 投诉指南列表
export const getComplaintGuideListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/complaint/guides`,
		params
	})
}

// 投诉指南详情
export const getComplaintGuideDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/complaint/guides/${params.complaintGuideId}`,
		params
	})
}

// 投诉指南新增/修改
export const saveComplaintGuideApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/complaint/guides/${data.complaintGuideId}`,
		data
	})
}

// 投诉指南删除
export const deleteComplaintGuideApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/complaint/guides/${data.complaintGuideId}`
	})
}

// 投诉指南 修改状态
export const updateComplaintGuideStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/complaint/guides/${data.complaintGuideId}/status`,
		data
	})
}

// 投诉指南 修改排序
export const updateComplaintGuideSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/complaint/guides/${data.complaintGuideId}/sort/${data.sort}`,
		data
	})
}

// 执行标准/处罚案例/投诉指南 话术编辑 查询
export const getBottomWordingApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/wording/bottom`,
		params
	})
}

// 执行标准/处罚案例/投诉指南 话术编辑 保存
export const saveBottomWordingApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/wording/bottom`,
		data
	})
}

// 评价7个接口
// 评价列表
export const getCommentListApi = (params) => {
  return axios({
    method: 'get',
    url: `/pet/manager/comments`,
    params
  })
}
// 27.0.0.1:9988/pet/manager/comments/{commentId}?pageNo=1&pageSize=10
export const getCommentsUserApi = (params) => {
  return axios({
    method: 'get',
    url: `/pet/manager/comments/${params.commentId}`,
    params
  })
}
// 评价 - 置顶 / 屏蔽
export const updateCommentStatusApi = (commentId, replyId,data) => {
  return axios({
    method: 'put',
    url: `/pet/manager/comments/${commentId}/status/reply/${replyId}`,
	  data
  })
}

export const addCommentsUserApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/comments/user/${data.factoryLangId}`,
		data
	})
}
// 评价 - 修改点赞数量
export const updateCommentLikeNumApi = (commentId, replyId, data) => {
  return axios({
    method: 'put',
    url: `/pet/manager/comments/${commentId}/comment/num/reply/${replyId}`,
    data
  })
}
// 评价 - 回复
export const replyCommentApi = (commentId, replyId, data) => {
  return axios({
    method: 'post',
    url: `/pet/manager/comments/${commentId}/reply/${replyId}`,
    data
  })
}

// 评价 - 删除回复
export const deleteCommentReplyApi = (commentId, replyId) => {
  return axios({
    method: 'delete',
    url: `/pet/manager/comments/${commentId}/status/reply/${replyId}`
  })
}

// 评价详情
export const getCommentDetailApi = (commentId, params) => {
  return axios({
    method: 'get',
    url: `/pet/manager/comments/${commentId}`,
    params
  })
}

// 单条评论详情（不含回复列表）
export const getCommentSingleApi = (commentId) => {
  return axios({
    method: 'get',
    url: `/pet/manager/comments/${commentId}`,
    params: { pageSize: 1 }
  })
}

// 回复详情
export const getCommentReplyDetailApi = (commentId, replyId) => {
  return axios({
    method: 'get',
    url: `/pet/manager/comments/${commentId}/reply/${replyId}`
  })
}
// ====================== 举报管理 ======================
// 举报列表
export const getReportsApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/reports`,
		params
	})
}

// 举报详情
export const getReportDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/reports/${params.reportId}`,
		params
	})
}

// 举报处理操作
export const handleReportApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/reports/${data.reportId}`,
		data
	})
}

// 举报 - 发送邮件
export const sendReportEmailApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/reports/${data.reportId}/message`,
		data
	})
}

// 互动管理==================================
// ====================== 敏感词管理 ======================
// 获取敏感词列表
export const getSensitiveWordsApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/sensitive/words`,
		params
	})
}

// 新增敏感词
export const addSensitiveWordApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/sensitive/words`,
		data
	})
}

// 删除敏感词
export const deleteSensitiveWordApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/sensitive/words/${data.wordId}`
	})
}

// 敏感词 导入
export const importSensitiveWordApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/sensitive/words/import`,
		data
	})
}

// 敏感词 导入模板
export const importSensitiveWordTemplateApi = () => {
	return axios({
		method: 'get',
		url: `/pet/manager/sensitive/words/import/template`,
		responseType: 'blob'
	})
}
// ====================== 评论用户管理 ======================
// 获取列表
export const getCommentManagerUsersApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/comment/manage/users`,
		params
	})
}

// 获取详情
export const getCommentManagerUserDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/comment/manage/users/${params.commentManagerUserId}`,
		params
	})
}

// 新增 / 编辑
export const saveCommentManagerUserApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/comment/manage/users/${data.commentManagerUserId}`,
		data
	})
}

// 删除
export const deleteCommentManagerUserApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/comment/manage/users/${data.commentManagerUserId}`,
	})
}

// 修改状态
export const StatusCommentManagerUserApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/comment/manage/users/${data.commentManagerUserId}/status`,
		data
	})
}

// 广告管理 start
export const getBannerListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/banner`,
		params
	})
}

// 广告管理 详情
export const getBannerDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/banner/${params.bannerId}`
	})
}


// 广告管理 新增/编辑
export const saveBannerApi = (data, generateQrCode) => {
	// 新增时 data.bannerId 为 0/undefined，不加后缀
	let url = data.bannerId ? `/pet/manager/banner/${data.bannerId}` : '/pet/manager/banner/0'
	if (generateQrCode) {
		url += '?generateQrCode=true'
	}
	return axios({
		method: 'post',
		url,
		data
	})
}

// 广告管理 删除
export const deleteBannerApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/banner/${data.bannerId}`
	})
}
// 广告管理 状态
export const updateBannerStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/banner/${data.bannerId}/status`,
		data
	})
}


// 广告管理 排序
export const updateBannerSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/banner/${data.bannerId}/sort/${data.sort}`
	})
}

// 广告管理 end

// 搜索管理 start
// 获取搜索推荐列表
export const getHotWordsListApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/hotwords',
		params
	})
}

// 获取搜索推荐详情
export const getHotWordsDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/hotwords/${params.hotwordId}`,
		params
	})
}

// 新增/编辑搜索推荐
export const saveHotWordsApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/hotwords/${data.hotwordId}`,
		data
	})
}

// 删除搜索推荐
export const deleteHotWordsApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/hotwords/${data.hotwordId}` // 修复了双斜杠错误
	})
}

// 修改搜索推荐状态
export const updateHotWordsStatusApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/hotwords/${data.hotwordId}/status`
	})
}

// 修改搜索推荐排序
export const updateHotWordsSortApi = (data) => {
	return axios({
		method: 'put',
		url: `/pet/manager/hotwords/${data.hotwordId}/sort/${data.sort}`
	})
}
// 搜索管理 end


// 上传文件
export const getOssAuth = function(params) {
	return axios({
		method: "get",
		url: "/pet/common/oss/auth",
		params
	});
};
// 登录
export const toLoginApi = function(data) {
	return axios({
		method: "POST",
		url: `/pet/manager/admin/login`,
		data
	});
};

// 英译
export const toTranslateApi = function(data) {
	return axios({
		method: "POST",
		url: `/pet/manager/admin/english/translation`,
		data
	});
};
export const logout = function() {
	return axios({
		method: "POST",
		url: `/pet/manager/admin/logout`,

	});
};
// 管理员修改密码
export const changePasswordApi = function(data) {
	return axios({
		method: "PUT",
		url: `/pet/manager/admin/password`,
		data
	});
};



// 系统设置
// 通用配置
export const generalSet = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/setting',
		params
	})
}
export const setGeneralSet = (data) => {
	return axios({
		method: 'POST',
		url: '/pet/manager/setting',
		data
	})
}
// 通用配置，修改
// 国家
export const getCountryApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/country',
		params
	})
}
export const setCountryApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/country/${data.countryId}`,
		data
	})
}
export const deleteCountryApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/country/${data.countryId}`
	})
}
// 系统设置 银行
export const getBanksApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/banks',
		params
	})
}
export const setBanksApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/banks/${data.bankId}`,
		data
	})
}
export const deleteBanksApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/banks/${data.bankId}`
	})
}
// 系统设置 内容列表
export const getProtocolsApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/protocols',
		params
	})
}
export const setProtocolsApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/protocols/${data.protocolId}`,
		data
	})
}
export const detailProtocolsApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/protocols/${data.protocolId}`,
		params
	})
}
// 版本管理

export const getVersionApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/app/versions',
		params
	})
}
export const setVersionApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/app/versions/${data.versionId}`,
		data
	})
}
export const deleteVersionApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/app/versions/${data.versionId}`
	})
}




// 资金管理
// 钱包明细
export const getRecordsApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/finance/records',
		params
	})
}

// 提现列表
export const getWithdrawsApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/withdraws',
		params
	})
}
// 提现详情
export const withdrawsDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/withdraws/${params.userWithdrawId}`,
		params: {

		}
	})
}

// 提现审核
export const withdrawsVerifyApi = (res) => {
	let data = {
		"withdrawStatus": res.withdrawStatus, //审核
		"remark": res.remark //备注
	}
	return axios({
		method: 'POST',
		url: `/pet/manager/withdraws/verify/${res.userWithdrawId}`,
		data
	})
}

// 通知管理
export const getNoticesApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/notices',
		params
	})
}
// 通知详情
export const getNoticesDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/notices/${params.noticeId}`,
		params
	})
}
// 删除，通知
export const noticesDelApi = (params) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/notices/${params.noticeId}`,
		params
	})
}
// 通知新增
export const getNoticesAddApi = (data) => {
	return axios({
		method: 'POST',
		url: '/pet/manager/notices',
		data
	})
}

// 会员升降级记录
export const userVipRecordslApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/user/vip/records',
		params
	})
}

export const userScoreRecordslApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/user/score/records',
		params
	})
}
// 会员修改
export const userEditlApi = (params) => {
	let data = {
		avatar: params.avatar,
		inviteCode: params.inviteCode,
		whatsApp: params.whatsApp,
		nickname: params.nickname,
		inviteUserId: params.inviteUserId,
		userStatus: params.userStatus,
		// password: params.password,
		// simulateStatus: params.simulateStatus
	}
	return axios({
		method: 'POST',
		url: `/pet/manager/users/${params.userId}`,
		data
	})
}


export const adjustEditlApi = (params) => {
	let data = {
		userRemark: params.userRemark,
		userBalance: params.userBalance,
		userType: params.userType
	}
	return axios({
		method: 'POST',
		url: `/pet/manager/users/balance/${params.userId}`,
		data
	})
}

// 会员导入
export const userImportApi = (data) => {
	return axios({
		method: 'POST',
		url: '/pet/manager/users/import',
		data,
		responseType: "form-data"
	})
}
// 银行卡列表
export const userBanksApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/user/banks',
		params
	})
}
// 银行卡修改
export const userBanksEditApi = (params) => {
	let data = {
		bankAccountName: params.bankAccountName,
		bankAccountNumber: params.bankAccountNumber,
		bankId: params.bankId,
	}
	return axios({
		method: 'POST',
		url: `/pet/manager/user/banks/${params.userBankId}`,
		data
	})
}
// 会员等级 get
export const userVipsApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/user/vips',
		params
	})
}
// 会员等级修改 post
export const userVipsEditApi = (data) => {
	return axios({
		method: 'POST',
		url: `/pet/manager/user/vips/${data.vipId}`,
		data
	})
}

// 排行榜 get
export const userStatisticsApi = (params) => {
	return axios({
		method: 'get',
		url: '/pet/manager/user/statistics?',
		params
	})
}



// 修改订单状态
// export const orderStatusApi = function (data) {
//   return axios({
//     method: "POST",
//     url: `/yin/manager/order/status`,
//     data
//   });
// };

// 发货
// export const orderDeliveryApi = function (data) {
//   return axios({
//     method: "POST",
//     url: `/yin/manager/order/delivery`,
//     data
//   });
// };


// 修改订单为异常订单/取消异常订单
// export const abnormalStatusApi = function (data) {
//   return axios({
//     method: "POST",
//     url: `/yin/manager/order/abnormal/status`,
//     data
//   });
// };

// 修改订单为停发订单/取消停发订单
// export const stopSendingStatusApi = function (data) {
//   return axios({
//     method: "POST",
//     url: `/yin/manager/order/stop/sending/status`,
//     data
//   });
// };

// 快递公司
export const expressListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/express/list`,
		params
	})
}


// 充值记录
export const rechargesListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/recharges`,
		params
	})
}
// 财务记录
export const financeListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/finance/records`,
		params
	})
}

// 角色-列表
export const roleListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/roles`,
		params
	})
}
// 角色-新增编辑
export const roleEditApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/role/${data.roleId}`,
		data
	})
}

// 角色-删除
export const roleDeleteApi = (data) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/role/${data.roleId}`,
	})
}

// 管理员-列表 okkk
export const userListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/admins`,
		params
	})
}
// 管理员-编辑 okkk
export const userEditApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/admin/${data.adminId}`,
		data
	})
}
// 管理员-删除 okkk
export const userDeleteApi = (params) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/admin/${params.adminId}`,
		params
	})
}

// 管理员-启用/禁用
export const enabledStatusApi = function(data) {
	return axios({
		method: "put",
		url: `/pet/manager/admin/${data.adminId}/enabledstatus`,
		data
	});
};

// 管理员-重置密码
export const userSetPassApi = function(data) {
	return axios({
		method: "put",
		url: `/pet/manager/admin/${data.adminId}/password`,
		data
	});
}

// Banner列表
// export const BannerListApi = (params) => {
//   return axios({
//       method: 'get',
//       url: `/yin/manager/banners`,
//       params
//   })
// }

// Banner编辑
// export const BannerEditApi = (data) => {
//   return axios({
//       method: 'post',
//       url: `/yin/manager/banners/${data.bannerId}`,
//       data
//   })
// }

// Banner删除
// export const BannerDeleteApi = (data) => {
//   return axios({
//       method: 'delete',
//       url: `/yin/manager/banners/${data.bannerId}`,
//   })
// }
// 首页小图配置列表
// export const ThumbnailListApi = (params) => {
//   return axios({
//       method: 'get',
//       url: `/yin/manager/homeimages`,
//       params
//   })
// }

// 首页小图配置编辑
// export const ThumbnailEditApi = (data) => {
//   return axios({
//       method: 'post',
//       url: `/yin/manager/homeimages/${data.imageId}`,
//       data
//   })
// }

// 首页小图配置删除
// export const ThumbnailDeleteApi = (data) => {
//   return axios({
//       method: 'delete',
//       url: `/yin/manager/homeimages/${data.imageId}`,
//   })
// }
// 操作指引
// export const instructionsApi = (params) => {
//   return axios({
//       method: 'get',
//       url: `/yin/manager/instructions`,
//       params
//   })
// }

// 操作指引编辑
// export const instructionsEditApi = (data) => {
//   return axios({
//       method: 'post',
//       url: `/yin/manager/instructions/${data.instructionId}`,
//       data
//   })
// }

// 操作指引删除
// export const instructionsDeleteApi = (data) => {
//   return axios({
//       method: 'delete',
//       url: `/yin/manager/instructions/${data.instructionId}`,
//   })
// }


// 通用配置
// export const getSettingApi = (params) => {
//   return axios({
//       method: 'get',
//       url: `/yin/manager/setting`,
//       params
//   })
// }
// 通用配置 修改
// export const editSettingApi = (data) => {
//   return axios({
//       method: 'post',
//       url: `/yin/manager/setting`,
//       data
//   })
// }

// 会员列表
// export const vipuserListApi = (params) => {
//   return axios({
//       method: 'get',
//       url: `/yin/manager/users`,
//       params
//   })
// }
// 会员详情
export const vipuserDetailApi = (params) => {
	return axios({
		method: 'get',
		url: `/yin/manager/users/${params.userId}`,
		params
	})
}

// ====================== 代工咨询模块 ======================
/**
 * 客服咨询列表
 * @param {Object} params 分页+筛选参数 pageNo/pageSize/inquiryNo/userName/status/startDate/endDate
 */
export const getInquireListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/inquires`,
		params
	})
}

/**
 * 代工咨询详情
 * @param {Object} data 携带 inquiryId 路径参数
 * @param {Object} params 额外url查询参数
 */
export const getInquireDetailApi = (data, params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/inquires/${data.inquiryId}`,
		params
	})
}

/**
 * 代工咨询编辑
 * @param {Object} data 路径参数adminId + 请求体数据
 */
export const editInquireApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/inquires/${data.inquiryId}`,
		data
	})
}

// ====================== 意见反馈模块 ======================
/**
 * 意见反馈列表
 * @param {Object} params 分页+筛选 pageNo/pageSize/feedbackNo/nickname/status/startDate/endDate
 */
export const getFeedbackListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/feedbacks`,
		params
	})
}

/**
 * 意见反馈详情
 * @param {Object} data 携带 feedbackId 路径参数
 * @param {Object} params 额外url查询参数
 */
export const getFeedbackDetailApi = (data, params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/feedbacks/${data.feedbackId}`,
		params
	})
}

/**
 * 意见反馈编辑
 * @param {Object} data 路径参数feedbackId + 请求体数据
 */
export const editFeedbackApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/feedbacks/${data.feedbackId}`,
		data
	})
}

/**
 * 意见反馈 - 发送消息
 * @param {Object} data 路径参数feedbackId + 请求体消息数据
 */
export const sendFeedbackMessageApi = (res) => {
	let data={
		replyContent:res.replyContent
	}
	return axios({
		method: 'post',
		url: `/pet/manager/feedbacks/${res.feedbackId}/send/message`,
		data
	})
}



// ====================== 留言频率管理 ======================
/**
 * 获取留言频率配置
 */
export const getFrequencySettingApi = () => {
	return axios({
		method: 'get',
		url: `/pet/manager/interaction/frequency/setting`
	})
}

/**
 * 编辑留言频率配置
 * @param {Object} data 提交修改的配置数据
 */
export const editFrequencySettingApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/interaction/frequency/setting`,
		data
	})
}

// ====================== 客服话术模板管理 ======================
/**
 * 客服话术列表
 * @param {Object} params pageNo/pageSize/templateType/keywords/lang
 */
export const getReplyTemplateListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/reply/templates`,
		params
	})
}

/**
 * 客服话术编辑/新增
 * @param {Object} data 携带 templateId 路径参数 + 表单数据
 */
export const editReplyTemplateApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/reply/templates/${data.templateId}`,
		data
	})
}

/**
 * 客服话术删除
 * @param {Object} params 携带 templateId 路径参数
 */
export const deleteReplyTemplateApi = (params) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/reply/templates/${params.templateId}`,
		params
	})
}

// ====================== 热线电话配置 ======================
/**
 * 获取热线电话配置
 */
export const getHotlineServiceApi = () => {
	return axios({
		method: 'get',
		url: `/pet/manager/hotline/service`
	})
}

/**
 * 编辑热线电话配置
 * @param {Object} data 修改后的热线数据
 */
export const editHotlineServiceApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/hotline/service`,
		data
	})
}

// ====================== 系统消息管理 ======================
/**
 * 系统消息列表
 * @param {Object} params pageNo/pageSize/keywords/startDate/endDate/lang
 */
export const getSystemMsgListApi = (params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/system/messages`,
		params
	})
}

/**
 * 系统消息详情
 * @param {Object} data 携带 messageId 路径参数
 * @param {Object} params 额外查询参数
 */
export const getSystemMsgDetailApi = (data, params) => {
	return axios({
		method: 'get',
		url: `/pet/manager/system/messages/${data.messageId}`,
		params
	})
}

/**
 * 系统消息新增/编辑
 * @param {Object} data 携带 messageId 路径参数 + 消息表单数据
 */
export const editSystemMsgApi = (data) => {
	return axios({
		method: 'post',
		url: `/pet/manager/system/messages/${data.messageId}`,
		data
	})
}

/**
 * 系统消息删除
 * @param {Object} params 携带 messageId 路径参数
 */
export const deleteSystemMsgApi = (params) => {
	return axios({
		method: 'delete',
		url: `/pet/manager/system/messages/${params.messageId}`,
		params
	})
}
